import { createApp, inject } from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";
import axios from "axios";
import moment from "moment";
import "./registerServiceWorker";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Paginate from "vuejs-paginate-next";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import "./assets/styles/custom.scss";
import './registerServiceWorker'
// import "bootstrap"
// import "bootstrap/dist/css/bootstrap.min.css"

const app = createApp(App);
app.use(VueSweetalert2);
app.use(store)
app.use(Paginate)
app.component('VueDatePicker', VueDatePicker);
window.Swal =  app.config.globalProperties.$swal;

let baseUrl="https://staging.crm.property-pistol.in/api/mobile_crm";
if(process.env.NODE_ENV === 'production'){
  baseUrl = "https://staging.crm.property-pistol.in/api/mobile_crm";
}
axios.defaults.baseURL = baseUrl;
//axios interceptors 
axios.interceptors.request.use(function(config) {
  store.dispatch('setLoading', true);
  if(config.url.indexOf('login') < 0){
    let token = localStorage.getItem('loan-crm-user-token')
    if(token){
      config.headers.Authorization = `Token token=${token}`
    }
  }
  config.headers['Content-Type'] = 'application/json'
  config.headers['Accept'] = 'application/json'
  return config;
}, function(err) {
  store.dispatch('setLoading', false);
  return Promise.reject(err);
});

axios.interceptors.response.use(function(response) {
  store.dispatch('setLoading', false);
  return response;
}, function(error){
  if(error.response.status === 401){
    localStorage.removeItem('loan-crm-user-token');
    Swal({
      title: "Session Expired",
      text: "You have been redirected to the login page",
      icon: "error"
    })
    .then(router.replace('/login'));
  }else{
    store.dispatch('setLoading', false);
    return Promise.reject(error);
  }
});

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('loan-crm-user-token')
  if(token && to.name === 'Login'){
    next({name: 'Home'});
  }else if(to.name !== 'Login' && !token){
    next({name: 'Login'});
  }else{
    if(to.name === 'Login'){
      store.dispatch('setLayout', 'login');
    }else{
      store.dispatch('setLayout', 'default');
    }
    next();
  }
})
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$axios = axios;
app.config.productionTip = false

app.use(router).mount('#app')

